// extracted by mini-css-extract-plugin
export var container = "styles-module--container--0V9al";
export var text = "styles-module--text--fdJ1C";
export var withShadow = "styles-module--withShadow--UPcDB";
export var noMargins = "styles-module--noMargins--smyE7";
export var centeredText = "styles-module--centeredText--TKCGD";